import { ArticleTable } from '../../components/molecule/ArticleContent/entry'
import { getPropsFromNode, nodeIs } from '../utils'
import { h } from '../parser/utils'

import { extractSide } from './_utils'

export const NAME = 'table'

export const COMPONENTS = {
  ArticleTable,
}

export function matches(node) {
  return nodeIs(node, 'table')
}

export async function transform (node, next, ctx) {
  if (node?.nodeType === ctx.window.Node.TEXT_NODE) {
    return node.textContent
  }

  const children = await next(node.childNodes, ctx)

  const props = getPropsFromNode(node)

  const side = extractSide(node)

  return h(
    ArticleTable, {
      ...props,
      ...(side ? { float: side } : null),
    },
    ...children,
  )
}
